import { useFlexLayout, useTable } from 'react-table';
import { Text, Flex, Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { ProfileLink } from '@/ui/ProfileLink';
import { Table } from '../activity-popup/table';
import { UserCard } from '../activity-popup/user-card';

export const CandidatesTable = ({ data = [] }) => {
  const columns = useMemo(() => {
    return [
      {
        Header: () => {
          return (
            <Text
              fontWeight="medium"
              fontSize="14px"
              textTransform="capitalize"
              color="#5E5E5E"
            >
              Candidates
            </Text>
          );
        },
        accessor: 'candidate',
        width: 120,
        Cell: ({ row }) => {
          const candidate = row?.original;
          return (
            <Flex>
              <UserCard contact={candidate} />
              <Box>
                <ProfileLink
                  linkedinUrl={candidate?.social?.linkedin}
                  greenhouseUrl={candidate?.ats?.greenhouse}
                  githubUrl={candidate?.social?.github}
                  leverurl={candidate?.ats?.lever}
                  ashbyUrl={candidate?.ats?.ashby}
                />
              </Box>
            </Flex>
          );
        },
      },
    ];
  }, []);

  const table = useTable(
    {
      columns,
      data: data || [],
    },
    useFlexLayout
  );

  return <Table table={table} />;
};
